import { observer } from 'mobx-react';
import { autoinject, bind, Duration, Enums, formatDuration, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { format } from 'date-fns';
import { LinkContainer } from 'react-router-bootstrap';
import { action } from 'mobx';
import { DisplayEventModal } from './DisplayEventModal';

export interface IWarrantyAlertLogItemProps {
    readonly displayAlert: Mri.DisplayAlerts.DisplayAlertLog;
    readonly rowNumber: number;
}

@autoinject
@observer
export class WarrantyAlertLogItem extends React.Component<IWarrantyAlertLogItemProps> {
    public render() {
        const { displayAlert, rowNumber } = this.props;
        return (
            <tr>
                <td>{rowNumber}</td>
                <td>{format(displayAlert.logTime, 'Pp')}</td>
                <td>{displayAlert.accountName}</td>
                <td>
                    <LinkContainer to={`/displays/${displayAlert.displaySerialNumber}`}>
                        <a className="btn btn-link">{displayAlert.displaySerialNumber}</a>
                    </LinkContainer>

                    <DisplayEventModal
                        displaySerialNumber={displayAlert.displaySerialNumber}
                        modalHandle={this.displayEventModalHandle}
                        eventGuid={displayAlert.displayEventGuid}
                    />
                </td>
                <td>
                    <a className="btn btn-link" onClick={this.openDisplayEventModal}>
                        View Event
                    </a>
                </td>
                <td>
                    <LinkContainer to={`/display-event-profiles/alerts/${displayAlert.displayEventProfileGuid}/edit`}>
                        <a className="btn btn-link">{displayAlert.profileName}</a>
                    </LinkContainer>
                </td>
                <td>{displayAlert.email}</td>
                <td>{displayAlert.eventDetails}</td>
                <td>{Enums.toString(Enums.DisplayEventStatus, displayAlert.displayEventStatus)}</td>
                <td>{formatDuration(new Duration(displayAlert.duration))}</td>
            </tr>
        );
    }


    @bind
    @action
    private openDisplayEventModal(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();

        this.displayEventModalHandle.open();
    }

    private displayEventModalHandle = new ModalHandle();
}
